import React from 'react';
import styles from './DesktopOfferSimulation.module.sass';
import theme from '../../App.module.sass';
import RadioGroup from "../ui/RadioGroup/RadioGroup";
import validation from "../../utils/validation";
import Input from "../ui/Input/Input";
import Button from '../ui/Button/Button';
import api from "../../utils/api";
import ordering from "../../utils/ordering";
import TitleSection from "../TitleSection/TitleSection";
import currency from "../../utils/currency";
import masks from '../../utils/masks';
import Table from '../ui/Table/Table';

class DesktopOfferSimulation extends React.Component {

  state = {
    open: false,
    simulationType: '',
    simulationValue: '',
    parcelas: [],
    openedIndex: -1
  };

  simulationRef = React.createRef();
  typeSimulationRef = React.createRef();
  
  componentDidMount(){
    this.typeSimulationRef.scrollIntoView({behavior: "smooth", block: "start"});
  }

  simulateHandler = () => {
    const input = document.getElementById("simulationValue");

    let validForm = true;
    let divToFocus;

    input.focus();
    input.blur();
    if (input.getAttribute("valid") === "false") {
      validForm = false;
      divToFocus = divToFocus ? divToFocus : input;
    }

    setTimeout(() => {
      if (input.getAttribute("valid") === "false") {
        validForm = false;
        divToFocus = divToFocus ? divToFocus : input;
      }

      if (validForm) {
        this.simulate();
      } else {
        divToFocus.scrollIntoView({behavior: "smooth", block: "start"});
      }
    }, 0);
  };

  simulate = () => {
    const requestBody = {
      codigoBem: this.props.oferta.codigoBem,
      codigoGrupo: this.props.oferta.identificacao.codigo,
      codigoPlano: this.props.oferta.dados.plano.identificacao.codigo,
      codigoVenda: this.props.oferta.identificacao.codigoVenda,
      codigoTaxa: this.props.oferta.dados.plano.identificacao.codigoTaxa,
      tipoOferta: this.state.simulationType,
      valor: this.state.simulationType === '%' ? this.state.simulationValue.replace('%', '') : currency.currencyToNumber(this.state.simulationValue)
    };

    api.get(api.endpoints.SIMULATION, null, requestBody).then((result) => {
      this.setState({parcelas: ordering.quotas(result.data)});
      this.simulationRef.scrollIntoView({behavior: "smooth", block: "start"})
    });
  };

  simulationTypeHandler = (value) => {
    if (value === '%') {
      this.setState({simulationType: value, simulationValue: '' + this.props.porcentagemLanceFixo + '%'});
    } else {
      this.setState({simulationType: value, simulationValue: ''});
    }
  };


  render() {
    return (
      <div className={styles.OfferSimulation} ref={(el) => this.typeSimulationRef = el}>
        <div className={[theme.row, styles.simulationForm].join(' ')}>
          <h2 className={styles.title}>Simular por:</h2>
          <div className={[styles.simulationType, theme.col33].join(' ')}>
            <RadioGroup
              options={['%', 'V'].map((el) => ({
                text: el === '%' ? 'Lance fixo' : 'Lance livre',
                value: el
              }))}
              value={this.state.simulationType}
              onChanged={this.simulationTypeHandler}
              className={theme.col60}
            >
              ></RadioGroup>
          </div>

          <Input
            className={theme.col33}
            value={this.state.simulationValue}
            onChange={(value) => {
              this.setState({simulationValue: value})
            }}
            typeDocument='Valor do lance'
            readonly={this.state.simulationType !== 'V'}
            mask={this.state.simulationType !== '%' && masks.currency}
            validationRules={[validation.required, validation.greaterThan(0), validation.lessThan(this.props.credito)]}
            validationTrigger='onChange'
            id='simulationValue'
          />

          <Button
            disabled={this.state.simulationType.length === 0}
            onClick={this.simulateHandler}>Simular
          </Button>
        </div>
        {
          this.state.parcelas.length > 0 &&
          <div ref={(el) => this.simulationRef = el}>
            <TitleSection title="Resultado da simulação"/>
            <Table headers={[
              {
                text: 'Parcelas',
                bold: true
              },
              {
                text: 'Com lance',
                bold: true
              },
              {
                text: 'Sem lance'
              }
            ]} rows={
              this.state.parcelas.map((el, index) => (
                {
                  interval: (el.inicio === el.fim ? el.inicio + "ª parcela" : "da " + el.inicio + "ª até a " + el.fim + "ª"),
                  comLance: ("R$ " + currency.numberToCurrency(el.valor)),
                  semLance: ("R$ " + currency.numberToCurrency(this.props.parcelas[index].valor)),
                }
              ))}/>
          </div>
        }
      </div>
    )
  }
}

export default DesktopOfferSimulation;
